import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

import Address from 'AppComponents/Address';
import AverageRating from 'AppComponents/AverageRating';

import './styles.scss';


const Charger = ({ charger, numRanked }) => (
  <li>

    <div styleName='ranking'>
      <div styleName='rank'>{ charger.average_rating_rank }</div>
      <div styleName='total'>
        <FormattedMessage
          id='rankingList.ranking.total'
          values={{ total: numRanked }}
          defaultMessage='of {total}'
        />
      </div>
    </div>

    <h3><Link to={`/charger/${charger.pk}/`}>{ charger.title }</Link></h3>

    <Address address={charger.address} />

    <AverageRating rating={charger.average_rating} styleName='average-rating' />

  </li>
);

Charger.propTypes = {
  charger: PropTypes.shape({
    title: PropTypes.string,
    address: PropTypes.object,
    average_rating: PropTypes.number,
    average_rating_rank: PropTypes.number,
  }).isRequired,
  numRanked: PropTypes.number.isRequired,
};

export default Charger;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Ranking/Charger.jsx